module.exports = __webpack_public_path__ + "assets/businessinsider.11733b64.svg";